import { useLiveQuery } from "dexie-react-hooks";
import { Ability } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted.ts";
import { photoDocQueueDB } from "../PhotoUpload/photoDocStorage.ts";

export function usePhotoDocUploadQueueTaskBar({
  enabled = true,
}: {
  enabled?: boolean;
} = {}): {
  hasTasks: boolean;
  failedCount: number;
} {
  const isPermitted = usePermitted();
  const shouldQuery =
    enabled && isPermitted([Ability.canCreatePhotoDocumentation]);

  const failedCount =
    useLiveQuery(
      () =>
        shouldQuery
          ? photoDocQueueDB.pendingUploads
              .where("status")
              .equals("failed")
              .count()
          : 0,
      [shouldQuery],
    ) ?? 0;

  return { hasTasks: shouldQuery && failedCount > 0, failedCount };
}
